//@ts-nocheck
import React, { Component } from "react";
import { observer } from "mobx-react";
import subscriptionState, {
  ISubsPlan,
} from "../../../shared/mobx/subscription-state";
import { formatNumberWithDecimal } from "../../../helpers/helpers";
import Spinner from "../../../components/bootstrap/Spinner";
import auth from "../../../shared/mobx/auth-state";

const currencyMapper = {
  USD: "$",
};

// Priority for file quality
const qualityOrder = {
  low: 1,
  medium: 2,
  high: 3,
};

// Keywords for device priority
const desktopKeywords = ["desktop", "laptop"];
const ipadKeywords = ["ipad", "tablet", "tab"];
const mobileKeywords = ["iphone", "samsung", "mobile", "galaxy"];

class PackagesSection extends Component {
  state = {
    activeTab: "month",
    isLoading: true,
    monthlyPackages: [],
    yearlyPackages: [],
    description: [],
  };

  componentDidMount() {
    this.fetchSubscriptionDescriptions();
    window.addEventListener("resize", this.setEqualHeight);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.setEqualHeight);
  }

  getDevicePriority = (value = "") => {
    const val = value.toLowerCase();
    if (desktopKeywords.some((k) => val.includes(k))) return 1;
    if (ipadKeywords.some((k) => val.includes(k))) return 2;
    if (mobileKeywords.some((k) => val.includes(k))) return 3;
    return 4; // Others
  };

  sortAccessDataByPriority = (accessData) => {
    if (!accessData || typeof accessData !== "object") return accessData;

    const sortedEntries = Object.entries(accessData).map(([key, value]) => {
      if (
        value &&
        typeof value === "object" &&
        value.options &&
        typeof value.options === "object"
      ) {
        let sortedOptions = Object.entries(value.options);

        if (key === "quality") {
          sortedOptions.sort(([, a], [, b]) => {
            return (
              (qualityOrder[a.value?.toLowerCase()] ?? 99) -
              (qualityOrder[b.value?.toLowerCase()] ?? 99)
            );
          });
        }

        if (key === "format") {
          sortedOptions.sort(([, a], [, b]) => {
            return (
              this.getDevicePriority(a.value) -
              this.getDevicePriority(b.value)
            );
          });
        }

        return [
          key,
          {
            ...value,
            options: Object.fromEntries(sortedOptions),
          },
        ];
      }

      return [key, value];
    });

    return Object.fromEntries(sortedEntries);
  };

  fetchSubscriptionDescriptions = async () => {
    try {
      this.setState({ isLoading: true });
      const packageList =
        await subscriptionState.getSubscriptiondescriptionPlans(false);

      const sortedDescription = packageList.access.map((plan) => ({
        ...plan,
        access: this.sortAccessDataByPriority(plan.access),
      }));

      this.setState({ description: sortedDescription });

      const newData: ISubsPlan[] = packageList;

      const mappedMonthlyPackages = this.mapPackages(newData, "month");
      const mappedYearlyPackages = this.mapPackages(newData, "year");

      this.setState(
        {
          monthlyPackages: mappedMonthlyPackages,
          yearlyPackages: mappedYearlyPackages,
          isLoading: false,
        },
        this.setEqualHeight
      );
    } catch (error) {
      console.error("Error fetching subscription descriptions:", error);
    }
  };

  mapPackages = (data: ISubsPlan[], cycle: "month" | "year") => {
    if (!Array.isArray(data)) return [];

    return data
      .filter((plan) => plan.billing_cycle?.interval === cycle)
      .map((plan) => ({
        id: plan.id,
        name: plan.name,
        features: [plan.description],
        price: `${currencyMapper[plan.unit_price?.currency_code] ?? plan.unit_price?.currency_code}${formatNumberWithDecimal(plan.unit_price?.amount)}/${plan.billing_cycle?.interval}`,
        icon: plan.icon,
      }));
  };

  setEqualHeight = () => {
    const packageCards = document.querySelectorAll(".packege-detail");
    let maxHeight = 0;

    packageCards.forEach((card) => {
      card.style.height = "auto";
      maxHeight = Math.max(maxHeight, card.clientHeight);
    });

    packageCards.forEach((card) => {
      card.style.height = `${maxHeight}px`;
    });
  };

  render() {
    const {
      activeTab,
      isLoading,
      description,
    } = this.state;

    return (
      <div className="container" id="pricing">
        <div className="packages-section">
          <h3>Find the perfect plan for your needs</h3>
          <h4>Explore Our Flexible Pricing Options</h4>
          <p>
            Discover the plan that best fits your requirements and start
            converting web pages to PDFs with ease. Whether you're a casual user
            or need extensive features, our pricing plans offer flexibility and
            value to suit your needs. Choose the right plan and enjoy seamless
            document management today!
          </p>
          <div className="tabs">
            <button
              className={`tab ${activeTab === "month" ? "active" : ""}`}
              onClick={() =>
                this.setState({ activeTab: "month" }, this.setEqualHeight)
              }
            >
              Monthly
            </button>
            <button
              className={`tab ${activeTab === "year" ? "active" : ""}`}
              onClick={() =>
                this.setState({ activeTab: "year" }, this.setEqualHeight)
              }
            >
              Yearly
            </button>
          </div>
          <style>
            {`
              .discount-banner-custom {
                background-color: #463B94 !important;
                width: fit-content;
                max-width: 100%;
                margin-left: auto;
                margin-right: auto;
                padding-right: 10px;
                min-width: 260px;
                margin-bottom: 30px !important;
                gap: 10px;
              }
              .discount-banner-custom .banner-text {
                font-size: 1.1rem;
                white-space: nowrap;
              }
              @media (min-width: 992px) {
                .discount-banner-custom .banner-text {
                  font-size: 2rem !important;
                }
              }
              .discount-banner-custom .icon {
                font-size: 2rem !important;
                color: #fff !important;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100%;
                margin: 0px -5px 0px -5px !important;
              }
              .discount-banner-custom .icon-wrapper {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100%;
                margin: 0px -25px 0px -35px !important;
              }
              /* Fix overlap on 1024px screens (laptop) */
              @media (min-width: 1024px) and (max-width: 1199.98px) {
                .discount-banner-custom .icon-wrapper {
                  margin: 0 !important;
                }
                .discount-banner-custom .banner-text {
                  font-size: 1.5rem !important;
                  white-space: normal;
                }
              }
              @media (max-width: 991.98px) {
                .discount-banner-custom .icon-wrapper {
                  margin: 0 !important;
                }
              }
            `}
          </style>
          <div
            className="discount-banner-custom my-4 px-4 py-3 d-flex align-items-center justify-content-center"
            style={{
              backgroundColor: "#463B94",
              width: "fit-content",
              maxWidth: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              minWidth: "260px",
            }}
          >
            <span className="icon-wrapper d-flex align-items-center justify-content-center" style={{height: "100%"}}>
              <i className="bi bi-bell-fill icon"></i>
            </span>
            <span className="banner-text fw-bold text-light text-center banner-text">
              Pay for 10 months, get{" "}
              <span className="text-highlight">2 months FREE!</span>
            </span>
          </div>

          <div className="packages">
            {isLoading ? (
              <Spinner size="4rem" color="danger" />
            ) : (
              <div className="row">
                {Array.isArray(description) && description.length > 0 ? (
                  description
                    .filter((plan) => plan.interval === activeTab)
                    .map((plan, index) => {
                      const accessData = plan.access;

                      return (
                        <div key={index} className="col-12 col-md-6 col-lg-3">
                          <div className="package card-stretch-full">
                            <div className="packege-header">
                              <div className="packege-price">
                                <h3 className="text-xl font-bold">
                                  {plan.title}
                                </h3>
                                <p className="price">
                                  {plan.unit_price
                                    ? `${currencyMapper[plan.unit_price.currency_code] ?? plan.unit_price.currency_code} ${formatNumberWithDecimal(plan.unit_price.amount)} / ${plan.interval}`
                                    : "No price available"}
                                </p>
                              </div>
                              <img
                                width="70px"
                                height="125px"
                                loading="lazy"
                                src={`/images/plan/${plan.icon}`}
                                alt={plan.title}
                                className="package-icon"
                              />
                            </div>
                            <div className="packege-detail">
                              <div
                                className="text-sm mb-2"
                                dangerouslySetInnerHTML={{
                                  __html: plan.description,
                                }}
                              />
                              <span className="text-uppercase">FEATURES</span>
                              <ul className="list-disc list-inside">
                                {Object.entries(accessData).map(
                                  ([key, value]) => {
                                    if (
                                      value &&
                                      typeof value === "object" &&
                                      value.label &&
                                      value.options
                                    ) {
                                      return (
                                        <li key={key}>
                                          <strong className="p-0">
                                            {value.tooltip ? (
                                              <tooltip className="custom-tooltip">
                                                {value.label}
                                                <span className="custom-tooltip-text">
                                                  {value.tooltip_text}
                                                </span>
                                              </tooltip>
                                            ) : (
                                              value.label
                                            )}
                                          </strong>

                                          {key === "Additional_features"
                                            ? ""
                                            : Object.entries(value.options).map(
                                                ([subKey, subValue]) => (
                                                  <ul
                                                    className="ps-3"
                                                    key={subKey}
                                                  >
                                                    <li>
                                                      {subValue.tooltip ? (
                                                        <tooltip className="custom-tooltip">
                                                          {subValue.label &&
                                                            `${subValue.label} : `}
                                                          {subValue.value}
                                                          <span className="custom-tooltip-text">
                                                            {
                                                              subValue.tooltip_text
                                                            }
                                                          </span>
                                                        </tooltip>
                                                      ) : (
                                                        <>
                                                          {subValue.label &&
                                                            `${subValue.label} : `}
                                                          {subValue.value}
                                                        </>
                                                      )}
                                                    </li>
                                                  </ul>
                                                )
                                              )}
                                        </li>
                                      );
                                    } else if (
                                      typeof value === "string" ||
                                      typeof value === "number"
                                    ) {
                                      return (
                                        <li key={key}>
                                          <strong>
                                            {key.charAt(0).toUpperCase() +
                                              key.slice(1)}
                                            :
                                          </strong>{" "}
                                          {value}
                                        </li>
                                      );
                                    }
                                    return null;
                                  }
                                )}
                              </ul>
                            </div>
                            <div className="packege-btn">
                              {auth.isUser && (
                                <button
                                  className="subscribe-btn"
                                  onClick={() =>
                                    (window.location.href = `/subscriptions`)
                                  }
                                >
                                  Choose Plan
                                </button>
                              )}
                              {auth.isGuest && (
                                <button
                                  className="subscribe-btn"
                                  onClick={() => {
                                    window.location.href = `/auth/sign-up?package_id=${plan.plan_id}`;
                                  }}
                                >
                                  Choose Plan
                                </button>
                              )}
                              {auth.isAdmin && (
                                <button className="subscribe-btn">
                                  Choose Plan
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })
                ) : (
                  <div>No descriptions available.</div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default observer(PackagesSection);
